import { Link } from "react-router-dom";

function InterProt() {
    return (
        <>
            <link rel="stylesheet" href="/assets/css/trade-union/interests-protection.css" />
            <section className="g-section g-banner__section">
                <div className="g-container">
                    <div className="g-row">
                        <div className="g-bread__crumbs g-dfw">
                            <a href="/" className="g-bc__item">главная</a>
                            <p className="g-bc__item">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.3">
                                    <path d="M7.5 9.75L3.75 6L7.5 2.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </svg>                                
                            </p>
                            <a href="/union" className="g-bc__item">Профсоюз</a>
                            <p className="g-bc__item">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g opacity="0.3">
                                    <path d="M7.5 9.75L3.75 6L7.5 2.25" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                                    </g>
                                </svg>                                
                            </p>
                            <p className="g-bc__item">Патриотизм</p>
                        </div>
                    </div>
                </div>
                
            </section>
            <section className="g-section g-post__section">
                <div className="g-container">
                    <div className="g-row">
                        <div className="g-post__content">
                            {/* <div className="g-post__banner__widget">
                                <img src="../assets/img/trade-union/isbg.png" alt=""/>
                            </div> */}
                            <div className="g-post__data g-dfw g-alt-center">
                                <h2 className="g-post__title">Патриотизм</h2>
                                
                            </div>
                            <div className="g-post__block">
                                <p className="g-post__text">
                                Мы развиваем социальную и культурную составляющую профсоюзной работы. Творческие конкурсы, волонтерское движение, массовые спортивные марафоны, чемпионаты по интеллектуальным играм – за каждым из этих направлений большое количество членов профсоюза и их семей. 
                                </p>
                                <p className="g-post__text">
                                Патриотическое воспитание и поддержание интереса к истории России – отдельный и крайне актуальный вектор социокультурной жизни Профсоюза и Общества в целом. 
                                </p>
                                <p className="g-post__text">
                                С целью сохранения памяти о Великой Отечественной войне, уважения к ветеранам и воинам, отдавших свои жизни в борьбе с немецко-фашистскими захватчиками, профсоюзная организация ежегодно проводит конкурс детского рисунка, поздравляет ветеранов Великой Отечественной войны с Днем Победы, принимает участие в возложении цветов к вечному огню и Всероссийской акции «Вахта памяти». 
                                </p>
                                <p className="g-post__text">
                                Кроме того, в «Газпром добыча Уренгой профсоюз» реализуется важнейший по своей значимости проект поисковых отрядов. Работники Общества успели поработать на Балтийской косе (Калининградская область), Бельском плацдарме (Тверская область), Суоярвском плацдарме (Республика Карелия).
                                </p>
                            </div>
                        </div>
                        <div className="g-post__sidebar">
                            <h2 className="g-post__sidebar__heading">Цели</h2>
                            <Link to="/union/interests-protection" className="g-mgtw__heading ">Защита интересов </Link>
                            <Link to="/union/job-safety-inner" className="g-mgtw__heading">Охрана труда</Link>
                            <Link to="/union/education" className="g-mgtw__heading">Обучение</Link>
                            <Link to="/union/sport" className="g-mgtw__heading">Спорт</Link>
                            <Link to="/union/programs" className="g-mgtw__heading">Программы</Link>
                            <Link to="/union/patriot" className="g-mgtw__heading active">Патриотизм</Link>
                            <Link to="/union/teens" className="g-mgtw__heading">Молодежь</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InterProt;